// 防抖
export function debounce(func, wait, immediate = true) {
  let timer = null;
  const _debounce = function(...args) {
    const context = this;
    if (timer) {
      clearTimeout(timer)
    }
    if (immediate) {
      if (!timer) { // null
        func.apply(this, args);
      }
      timer = setTimeout(() => {
        timer = null;
      }, wait)
    } else {
      timer = setTimeout(() => {
        func.apply(context, args);
        timer = null;
      }, wait)
    }
  }
  _debounce.cancel = function() {
    clearTimeout(timer);
    timer = null;
  }
  return _debounce;
}

// 节流
export function throttle(func, wait, options = {}) {
  let timer = null;

  const _throttle = function(...args) {
    const context = this;
    if (!timer) {
      timer = setTimeout(() => {
        func.apply(context, args);
        timer = null;
      }, wait)
    }
  }
  return _throttle;
}

export function getQueryStringArgs() {
  // 取得查询字符串并去掉开头的问号
  var qs = (location.search.length > 0 ? location.search.substring(1) : '');
  // 保存数据的对象
  var args = {};
  // 取得每一项
  var items = qs.length ? qs.split('&') : [];
  var item = null;
  var name = null;
  var value = null;
  // 在 for 循环中使用
  var i = 0;
  var len = items.length;
  // 逐个将每一项添加到 args 对象中
  for (i = 0; i < len; i++) {
    item = items[i].split('=');
    name = decodeURIComponent(item[0]);
    value = decodeURIComponent(item[1]);
    if (name.length) {
      args[name] = value;
    }
  }
  return args;
}
